import { render, staticRenderFns } from "./punch.vue?vue&type=template&id=af4deb3a&scoped=true&"
import script from "./punch.vue?vue&type=script&lang=js&"
export * from "./punch.vue?vue&type=script&lang=js&"
import style0 from "./punch.vue?vue&type=style&index=0&id=af4deb3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4deb3a",
  null
  
)

export default component.exports